"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (string, suffix) {
  return string.substr(-suffix.length) === suffix;
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/polished/lib/internalHelpers/_endsWith.js
// module id = 607
// module chunks = 168707334958949